import { render, staticRenderFns } from "./ConfirmAttachmentModal.vue?vue&type=template&id=52f42791&"
import script from "./ConfirmAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAttachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAttachmentModal.vue?vue&type=style&index=0&id=52f42791&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports